// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2FPUA","upload":"Small_upload__xGZR_","imageWrap":"Small_imageWrap__R6ehA","removeBtn":"Small_removeBtn__c7Jjg"};